'use strict'

import React from 'react'
import PropTypes from 'prop-types'

class ErrorRerenderer extends React.Component {
  constructor (props) {
    super(props)
    this.state = { errorCount: 0 }
  }

  componentDidCatch (error, info) {
    console.log(error)
    this.setState({
      errorCount: this.state.errorCount + 1
    })
  }

  render () {
    const component = this.props.children

    // Prevent infinite loop of rerendering
    const maxRerenderAttempts = this.props.retries
    if (this.state.errorCount > maxRerenderAttempts) {
      return this.props.fallback ? this.props.fallback : null
    }

    return component
  }
}

ErrorRerenderer.propTypes = {
  children: PropTypes.object.isRequired,
  fallback: PropTypes.object,
  retries: PropTypes.number
}

ErrorRerenderer.defaultProps = {
  retries: 1
}

export default ErrorRerenderer
